import { useMemo } from "react";
import { useWedding } from "../contexts/wedding-context";

/**
 * Public config'ten kayıt penceresi — sunucu son söz sahibi, bu yalnız ön
 * kontrol (kapalıysa boşuna istek/SMS gitmesin). Hem join sayfası
 * (`JoinRegisterForm`) hem auth sayfası kayıt formu (`AuthRegisterForm`) kullanır.
 */
export function useRegistrationWindow(): { open: boolean } {
  const { wedding } = useWedding();
  return useMemo(() => {
    const reg = (wedding?.config as { registration?: {
      allowSelfRegister?: boolean;
      registrationOpensAt?: string | null;
      registrationClosesAt?: string | null;
    } } | undefined)?.registration ?? {};

    const now = Date.now();
    const closesAt = reg.registrationClosesAt ? new Date(reg.registrationClosesAt).getTime() : null;
    if (closesAt !== null && closesAt <= now) return { open: false };

    const opensAt = reg.registrationOpensAt ? new Date(reg.registrationOpensAt).getTime() : null;
    const autoOpen = opensAt !== null && opensAt <= now;
    return { open: reg.allowSelfRegister !== false || autoOpen };
  }, [wedding?.config]);
}
